import { executeRequest, JFSRequest } from '@jfs/network'
import { isEmpty } from '@jfs/utils'
import { isSuccessResponse } from './../utils/index'
import { APIEndPoints } from './APIEndPoints'
import { getHeaders, getUrl, sitConfig } from './config'

const responseParser = (response: any) => {
  const data = isSuccessResponse(response)
  return {
    frequencyId: '' + data?.payoutConfig?.frequencyId ?? 0,
    autoSettle: data?.payoutConfig?.autoSettle ?? false,
    autoSettleDays: isEmpty(data?.payoutConfig?.autoSettleDays) ? '0' : '' + data?.payoutConfig?.autoSettleDays,
    settlementOnHold: data?.payoutConfig?.payoutSettleHold ?? false,
    isDynamicSettlement: data?.payoutConfig?.checker ?? false,
    remarks: data?.payoutConfig?.remarks ?? '',
  }
}

const getMidPayoutConfig = (mid: any, tokens: any) => {
  const { REACT_APP_CHANNEL_ID = '' } = window?._env_
  const request: JFSRequest<{}> = {
    apiPath: getUrl(APIEndPoints.retrieveMidPayoutConfig),
    method: 'POST',
    cache: false,
    config: sitConfig(tokens),
    headers: getHeaders(),
    body: {
      entity: {
        initiatingEntityId: REACT_APP_CHANNEL_ID,
        entityId: mid,
      },
    },
  }

  return executeRequest(request)
    .then(responseParser)
    .catch((error) => {
      throw error
    })
}

export { getMidPayoutConfig }
